import React, { useRef, useState, useEffect, useLayoutEffect } from 'react';
import { useAccordionItem } from './AccordionItem.js';
import { useAccordionRoot } from './AccordionRootProvider.js';
import { StyledAccordionContent } from './styles.js';

// eslint-disable-next-line @typescript-eslint/ban-types
function AccordionContent({ children }) {
    const { openedAccordion } = useAccordionRoot();
    const { value } = useAccordionItem();
    const contentRef = useRef(null);
    const [height, setHeight] = useState(0);
    const isOpened = openedAccordion === value;
    const [isVisible, setIsVisible] = useState(false);
    useEffect(() => {
        if (isOpened) {
            setIsVisible(true);
        }
    }, [isOpened]);
    useLayoutEffect(() => {
        const node = contentRef.current;
        if (isVisible && node && !height) {
            const rect = node.getBoundingClientRect();
            setHeight(rect.height);
        }
    }, [isVisible]);
    return (React.createElement(StyledAccordionContent, { ref: contentRef, height: height, isOpened: isOpened, onAnimationEnd: () => {
            if (!isOpened) {
                setIsVisible(false);
            }
        } }, isVisible && children));
}

export { AccordionContent };
